import { cn } from '@/utils';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import Button from '../common/button';
import SelectRecommenderModal from '.';
import {
	ButtonSelectRecommenderProps,
	IProps as ISelectApplicantProps,
} from './select-recommender-modal.type';

const SelectRecommenderButton = (props: ButtonSelectRecommenderProps) => {
	const { label = '추가', className, ...rest } = props;

	const [open, setOpen] = useState(false);

	const selectRecommenderModal =
		useRef<FunctionComponent<ISelectApplicantProps>>();

	const onOpenModal = useCallback(() => {
		if (!selectRecommenderModal.current) {
			selectRecommenderModal.current = SelectRecommenderModal;
		}

		setOpen(true);
	}, []);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			<Button
				secondary
				className={cn('min-w-0', className)}
				onClick={onOpenModal}
			>
				{label}
			</Button>

			{selectRecommenderModal.current && (
				<selectRecommenderModal.current {...{ ...rest, open, onCancel }} />
			)}
		</>
	);
};

export default memo(SelectRecommenderButton);
